/**
 * Created by phuongho on 10/16/16.
 */
import { BaseSearchModel } from './base.search.model';

export class SearchGenreModel extends BaseSearchModel {
    public key: string;
}
